








import {Component, Prop, Vue} from 'vue-property-decorator';

import OpenHubSharedLogic from '@/views/components/openHub/OpenHubSharedLogic.vue';
import {OPEN_HUB_MODES} from "@/constants/openHub";


@Component({
  name: 'DepositItem',
  components: {
    OpenHubSharedLogic,
  },
})
export default class DepositItem extends Vue {
  @Prop()
  private asId!: string;

  private hubMode: OPEN_HUB_MODES = OPEN_HUB_MODES.DEPOSIT;
}
